export default "__VITE_ASSET__sX5DWKCB__"